<template>
  <div class="buyerLayout">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "buyerLayout",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.buyerLayout {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>